import { AppNavigation } from '@layout/core/interfaces';

export class AppNavigationCreator {
    static create(item: AppNavigation) {
        return {
            ...item,
        };
    }
}
